// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb-item + .breadcrumb-item::before {
  content: ">";
  color: white;
  /* White separator */
}

.dashboard-cancel-btn {
  width: 100%;
}

.images_stats {
  width: 50px;
  height: 50px;
}

.table12 {
  width: 100%;
  align-items: center;
}

.table12 th,
.table1 td {
  font-size: clamp(0.85rem, 2vw, 0.95rem);
  padding: clamp(8px, 2vw, 10px);
  border-color: var(--light);
}

.table12 th {
  background: var(--background-light);
  font-weight: 600;
  color: var(--text-dark);
  font-size: 0.9rem;
  font-weight: 800;
  color: #333;
  padding: 15px;
  border-bottom: 1px solid #e5e5e5;
}

.table12 th,
.table12 td {
  font-size: clamp(0.85rem, 2vw, 0.95rem);
  padding: clamp(8px, 2vw, 10px);
  border-color: var(--light);
}

.table12 td {
  padding: 15px;
  font-size: 0.9rem;
  color: #555;
  vertical-align: middle;
  border-bottom: 1px solid #e5e5e5;
  background: #fff;
}

.font-medium {
  padding-left: 15px;
}

/* Styles for dashboard avatar images */
.dashboard-avatar {
  display: inline-block;
  position: relative;
}

.dashboard-avatar-sm {
  width: 40px;
  height: 40px;
  gap: 10px;
}

.dashboard-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.dashboard-table-avatar {
  display: flex;
  align-items: center;
}

.dashboard-table-head-name {
  flex-grow: 1;
}

/* Base styles */
.dashboard-section {
  padding: 1.5rem 0;
}

.div-row {
  margin-right: 0px;
}

.dashboard-icon-menu {
  justify-content: center;
}

flex-wrap lg:flex-nowrap .stats-row {
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(4, 1fr);
  /* 4 equal columns */
  gap: 42px;
  /* space between cards */
  width: 100%;
}

.stats-row > div {
  background: #f9fafb;
  /* light gray background */
  width: 230px;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease;
}

.stats-row > div:hover {
  transform: translateY(-4px);
}

.stats-row h5 {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
}

.stats-row p {
  font-size: 0.875rem;
  color: #6b7280;
  /* gray-600 */
}

/* Responsive - stack on small screens */
@media (max-width: 768px) {
  .stats-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .stats-row {
    grid-template-columns: 1fr;
  }
}

/* Base styles */
.dashboard-section {
  padding: 1.5rem 0;
}

/* Statistics card layout */
.statistics-card .stats-row {
  display: flex;
  flex-wrap: wrap;
  /* Default: wrap on smaller screens */
  gap: 1rem;
}

@media (min-width: 1024px) {
  .statistics-card .stats-row {
    flex-wrap: nowrap;
    /* Force single row on laptop & desktop */
  }
}

.dashboard-icon-menu {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  gap: 2rem;
}

.dashboard-icon-item {
  text-align: center;
  flex: 0 0 auto;
  min-width: 80px;
}

.card {
  width: 100%;
}

.table {
  width: 100%;
  min-width: 600px;
}

.table td,
.table th {
  padding: 0.5rem;
  vertical-align: middle;
}

.appointment-info ul {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 1rem;
}

.appointment-info li {
  flex: 0 0 auto;
}

.dropdown-menu {
  min-width: 120px;
}

/* Large screens (laptops and above) */
@media (min-width: 1024px) {
  .dashboard-icon-menu {
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    gap: 2.5rem;
  }

  .dashboard-icon-item {
    min-width: 100px;
  }

  .dashboard-icon-item span {
    font-size: 1rem;
  }

  .dashboard-icon-item svg {
    font-size: 1.5rem;
  }
}

/* Medium screens (tablets) */
@media (max-width: 1023px) and (min-width: 768px) {
  .dashboard-icon-menu {
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    gap: 1.5rem;
  }

  .dashboard-icon-item {
    min-width: 80px;
  }
}

/* Small screens (mobile) */
@media (max-width: 767px) {
  .dashboard-icon-menu {
    flex-direction: row;
    align-items: center;
    gap: 1rem;
  }

  .dashboard-icon-item {
    width: 100%;
    max-width: 150px;
  }

  .herosection {
    padding: 1rem 0.5rem !important;
  }

  .card {
    padding: 1rem !important;
  }

  .card-header h4 {
    font-size: 1.1rem;
  }

  .card-header p {
    font-size: 0.85rem;
  }

  .table {
    min-width: 500px;
  }

  .academy-img img {
    width: 40px !important;
    height: 40px !important;
  }

  .appointment-info li {
    min-width: 100px !important;
  }

  .appointment-info img {
    width: 50px !important;
    height: 50px !important;
  }

  h5,
  h6 {
    font-size: 0.9rem !important;
  }

  p,
  span,
  li {
    font-size: 0.8rem !important;
  }
}

@media (max-width: 576px) {
  .breadcrumb h1 {
    font-size: 1.5rem;
  }

  .statistics-card .grid {
    grid-template-columns: 1fr;
  }

  .table {
    min-width: 400px;
  }

  .table th,
  .table td {
    font-size: 0.75rem;
  }

  .dropdown-menu {
    font-size: 0.8rem;
  }
}

.dashboard-icon-menu {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
}

.dashboard-icon-item {
  text-align: center;
}

.card {
  width: 100%;
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table {
  width: 100%;
  min-width: 600px;
  /* Ensures table scrolls on small screens */
}

.table td,
.table th {
  padding: 0.5rem;
  vertical-align: middle;
}

.appointment-info ul {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 1rem;
}

.appointment-info li {
  flex: 0 0 auto;
}

.dropdown-menu {
  min-width: 120px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .dashboard-icon-menu {
    flex-direction: row;
    align-items: center;
  }

  .dashboard-icon-item {
    width: 100%;
    max-width: 150px;
  }

  .herosection {
    padding: 1rem 0.5rem !important;
  }

  .card {
    padding: 1rem !important;
  }

  .card-header h4 {
    font-size: 1.1rem;
  }

  .card-header p {
    font-size: 0.85rem;
  }

  .table {
    min-width: 500px;
  }

  .academy-img img {
    width: 40px !important;
    height: 40px !important;
  }

  .appointment-info li {
    min-width: 100px !important;
  }

  .appointment-info img {
    width: 50px !important;
    height: 50px !important;
  }

  h5,
  h6 {
    font-size: 0.9rem !important;
  }

  p,
  span,
  li {
    font-size: 0.8rem !important;
  }
}

@media (max-width: 576px) {
  .breadcrumb h1 {
    font-size: 1.5rem;
  }

  .statistics-card .grid {
    grid-template-columns: 1fr;
  }

  .table {
    min-width: 400px;
  }

  .table th,
  .table td {
    font-size: 0.75rem;
  }

  .dropdown-menu {
    font-size: 0.8rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/css/userDashboard.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,uCAAuC;EACvC,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,gCAAgC;AAClC;;AAEA;;EAEE,uCAAuC;EACvC,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qCAAqC;EACrC,oBAAoB;EACpB,SAAS;EACT,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,eAAe;EACf,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,iBAAiB;IACjB,yCAAyC;EAC3C;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE;IACE,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;;IAGE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;;EAEE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;;IAGE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".breadcrumb-item + .breadcrumb-item::before {\n  content: \">\";\n  color: white;\n  /* White separator */\n}\n\n.dashboard-cancel-btn {\n  width: 100%;\n}\n\n.images_stats {\n  width: 50px;\n  height: 50px;\n}\n\n.table12 {\n  width: 100%;\n  align-items: center;\n}\n\n.table12 th,\n.table1 td {\n  font-size: clamp(0.85rem, 2vw, 0.95rem);\n  padding: clamp(8px, 2vw, 10px);\n  border-color: var(--light);\n}\n\n.table12 th {\n  background: var(--background-light);\n  font-weight: 600;\n  color: var(--text-dark);\n  font-size: 0.9rem;\n  font-weight: 800;\n  color: #333;\n  padding: 15px;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.table12 th,\n.table12 td {\n  font-size: clamp(0.85rem, 2vw, 0.95rem);\n  padding: clamp(8px, 2vw, 10px);\n  border-color: var(--light);\n}\n\n.table12 td {\n  padding: 15px;\n  font-size: 0.9rem;\n  color: #555;\n  vertical-align: middle;\n  border-bottom: 1px solid #e5e5e5;\n  background: #fff;\n}\n\n.font-medium {\n  padding-left: 15px;\n}\n\n/* Styles for dashboard avatar images */\n.dashboard-avatar {\n  display: inline-block;\n  position: relative;\n}\n\n.dashboard-avatar-sm {\n  width: 40px;\n  height: 40px;\n  gap: 10px;\n}\n\n.dashboard-avatar-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 4px;\n}\n\n.dashboard-table-avatar {\n  display: flex;\n  align-items: center;\n}\n\n.dashboard-table-head-name {\n  flex-grow: 1;\n}\n\n/* Base styles */\n.dashboard-section {\n  padding: 1.5rem 0;\n}\n\n.div-row {\n  margin-right: 0px;\n}\n\n.dashboard-icon-menu {\n  justify-content: center;\n}\n\nflex-wrap lg:flex-nowrap .stats-row {\n  display: grid;\n  justify-content: center;\n  grid-template-columns: repeat(4, 1fr);\n  /* 4 equal columns */\n  gap: 42px;\n  /* space between cards */\n  width: 100%;\n}\n\n.stats-row > div {\n  background: #f9fafb;\n  /* light gray background */\n  width: 230px;\n  border-radius: 8px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  transition: transform 0.2s ease;\n}\n\n.stats-row > div:hover {\n  transform: translateY(-4px);\n}\n\n.stats-row h5 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.stats-row p {\n  font-size: 0.875rem;\n  color: #6b7280;\n  /* gray-600 */\n}\n\n/* Responsive - stack on small screens */\n@media (max-width: 768px) {\n  .stats-row {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 480px) {\n  .stats-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Base styles */\n.dashboard-section {\n  padding: 1.5rem 0;\n}\n\n/* Statistics card layout */\n.statistics-card .stats-row {\n  display: flex;\n  flex-wrap: wrap;\n  /* Default: wrap on smaller screens */\n  gap: 1rem;\n}\n\n@media (min-width: 1024px) {\n  .statistics-card .stats-row {\n    flex-wrap: nowrap;\n    /* Force single row on laptop & desktop */\n  }\n}\n\n.dashboard-icon-menu {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: center;\n  gap: 2rem;\n}\n\n.dashboard-icon-item {\n  text-align: center;\n  flex: 0 0 auto;\n  min-width: 80px;\n}\n\n.card {\n  width: 100%;\n}\n\n.table {\n  width: 100%;\n  min-width: 600px;\n}\n\n.table td,\n.table th {\n  padding: 0.5rem;\n  vertical-align: middle;\n}\n\n.appointment-info ul {\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  gap: 1rem;\n}\n\n.appointment-info li {\n  flex: 0 0 auto;\n}\n\n.dropdown-menu {\n  min-width: 120px;\n}\n\n/* Large screens (laptops and above) */\n@media (min-width: 1024px) {\n  .dashboard-icon-menu {\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: center;\n    gap: 2.5rem;\n  }\n\n  .dashboard-icon-item {\n    min-width: 100px;\n  }\n\n  .dashboard-icon-item span {\n    font-size: 1rem;\n  }\n\n  .dashboard-icon-item svg {\n    font-size: 1.5rem;\n  }\n}\n\n/* Medium screens (tablets) */\n@media (max-width: 1023px) and (min-width: 768px) {\n  .dashboard-icon-menu {\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: center;\n    gap: 1.5rem;\n  }\n\n  .dashboard-icon-item {\n    min-width: 80px;\n  }\n}\n\n/* Small screens (mobile) */\n@media (max-width: 767px) {\n  .dashboard-icon-menu {\n    flex-direction: row;\n    align-items: center;\n    gap: 1rem;\n  }\n\n  .dashboard-icon-item {\n    width: 100%;\n    max-width: 150px;\n  }\n\n  .herosection {\n    padding: 1rem 0.5rem !important;\n  }\n\n  .card {\n    padding: 1rem !important;\n  }\n\n  .card-header h4 {\n    font-size: 1.1rem;\n  }\n\n  .card-header p {\n    font-size: 0.85rem;\n  }\n\n  .table {\n    min-width: 500px;\n  }\n\n  .academy-img img {\n    width: 40px !important;\n    height: 40px !important;\n  }\n\n  .appointment-info li {\n    min-width: 100px !important;\n  }\n\n  .appointment-info img {\n    width: 50px !important;\n    height: 50px !important;\n  }\n\n  h5,\n  h6 {\n    font-size: 0.9rem !important;\n  }\n\n  p,\n  span,\n  li {\n    font-size: 0.8rem !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .breadcrumb h1 {\n    font-size: 1.5rem;\n  }\n\n  .statistics-card .grid {\n    grid-template-columns: 1fr;\n  }\n\n  .table {\n    min-width: 400px;\n  }\n\n  .table th,\n  .table td {\n    font-size: 0.75rem;\n  }\n\n  .dropdown-menu {\n    font-size: 0.8rem;\n  }\n}\n\n.dashboard-icon-menu {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.dashboard-icon-item {\n  text-align: center;\n}\n\n.card {\n  width: 100%;\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.table {\n  width: 100%;\n  min-width: 600px;\n  /* Ensures table scrolls on small screens */\n}\n\n.table td,\n.table th {\n  padding: 0.5rem;\n  vertical-align: middle;\n}\n\n.appointment-info ul {\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  gap: 1rem;\n}\n\n.appointment-info li {\n  flex: 0 0 auto;\n}\n\n.dropdown-menu {\n  min-width: 120px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .dashboard-icon-menu {\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .dashboard-icon-item {\n    width: 100%;\n    max-width: 150px;\n  }\n\n  .herosection {\n    padding: 1rem 0.5rem !important;\n  }\n\n  .card {\n    padding: 1rem !important;\n  }\n\n  .card-header h4 {\n    font-size: 1.1rem;\n  }\n\n  .card-header p {\n    font-size: 0.85rem;\n  }\n\n  .table {\n    min-width: 500px;\n  }\n\n  .academy-img img {\n    width: 40px !important;\n    height: 40px !important;\n  }\n\n  .appointment-info li {\n    min-width: 100px !important;\n  }\n\n  .appointment-info img {\n    width: 50px !important;\n    height: 50px !important;\n  }\n\n  h5,\n  h6 {\n    font-size: 0.9rem !important;\n  }\n\n  p,\n  span,\n  li {\n    font-size: 0.8rem !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .breadcrumb h1 {\n    font-size: 1.5rem;\n  }\n\n  .statistics-card .grid {\n    grid-template-columns: 1fr;\n  }\n\n  .table {\n    min-width: 400px;\n  }\n\n  .table th,\n  .table td {\n    font-size: 0.75rem;\n  }\n\n  .dropdown-menu {\n    font-size: 0.8rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
